module.exports = __webpack_public_path__ + "img/nutraceuticals.87f43783.png";